/**
 * Validates a domain for SAML SSO.
 * @param {string} input - The domain to validate.
 * @returns {string|null} The validated domain or null if invalid.
 */
export default function validateDomain(input) {
	try {
		// Add scheme if missing, to enable full URL parsing
		const withScheme = input.includes("://") ? input : `https://${input}`;
		const url = new URL(withScheme);

		const hostname = url.hostname; // normalized, punycode-safe

		// Validate hostname format (not an IP address, not localhost, etc.)
		const isValid =
		/^[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,63}$/i.test(hostname) &&
		!/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname); // avoid IPv4

		if (!isValid) return null;

		return hostname.toLowerCase();
	} catch {
		return null;
	}
}